import styles from "./Content.module.scss"
import cx from "classnames"

const HeadlineContent = ({ content }) => {
  const { text } = content

  if (!text) return null

  return <div className="mb-4 font-semibold text-body last:mb-6">{text}</div>
}

const TextContent = ({ content }) => {
  const { text } = content

  if (!text) return null

  return <div className="mb-4 text-body-small last:mb-6">{text}</div>
}

const ListContent = ({ content }) => {
  const { list } = content

  if (!list) return null

  return (
    <div className="mb-4 text-body-small last:mb-6">
      <ul>
        {list.map((element, i) => (
          <li
            className="list-disc list-inside text-body-small font-normal"
            key={i}
          >
            {element}
          </li>
        ))}
      </ul>
    </div>
  )
}

const CONTENTS = {
  headline: HeadlineContent,
  text: TextContent,
  list: ListContent,
}

const ContentField = ({ field, className }) => {
  const { contents } = field

  return (
    <div className={cx(styles.contentWrapper, "mt-12 first:mt-0", className)}>
      {contents &&
        contents?.map((content, i) => {
          const Content = CONTENTS?.[content?.content_type]

          return Content ? <Content key={i} content={content} /> : null
        })}
    </div>
  )
}

export default ContentField
